import { userAdmin } from "@/app/api";
import { ReactNode } from "react";

interface AdminAccessProps {
  children: ReactNode;
}

export async function AdminRoute({ children }: AdminAccessProps) {
  const isAdmin = await userAdmin();

  if (!isAdmin) {
    return null
  }

  return <>{children}</>
}